import { http } from "msw";
import { customResponse } from "../../../mocks/customResponse";
import { HTTP_AUTH } from "../../enums/httpEnum";

export const mockAuthHandlers = [
  /**
   * Handler for fetch mock verify user
   */
  http.get(HTTP_AUTH.VERIFY_INVITE_LINK, async ({ params }) => {
    console.log(params);
    return customResponse({
      first_name: "John",
      last_name: "doe",
      organization: "BS",
      phone_number: "+8801111111111",
      email: "bs-cp@yopmail.com",
      root_org: "UNKNOWN",
    });
  }),
];
